export default __webpack_public_path__ + "static/media/05_o_1.1d07a31d.jpg";